//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {queryunhandlealarm, handleallalarm} from '../../api/device'

export default {
  model: {
    prop: 'unhandlAlarmShow',
    event: 'change'
  },
  name: 'alarmList',
  data () {
    return {
      deviceData: {},
      alarmList: [],
      cnt: 10,
      addWarn: false,
      showAdd: false,
      iconType: [
        {type: 'dooropen', url: '../../../static/NB/second_history_opendoor.png'},
        {type: 'doorclose', url: '../../../static/NB/second_history_closedoor.png'},
        {type: 'sos', url: '../../../static/NB/second_history_SOS.png'},
        {type: 'c-at', url: '../../../static/NB/second_history_dismantle.png'},
        {type: '', url: '../../../static/NB/second_history_other.png'}
      ]
    }
  },
  created () {
    this.deviceData = this.$store.getters.get_child_obj
    if (this.deviceData.unhandlealarm > 100) {
      this.cnt = 100
    } else {
      this.cnt = this.deviceData.unhandlealarm
    }
    this.getAlarmList()
  },
  methods: {
    getAlarmList () {
      // 建议unhandlealarm  < 100 ,填入具体数值；unhandlealarm  > 100 填入100
      let data = {
        dids: [this.deviceData.id],
        page: 1,
        cnt: this.cnt
      }
      queryunhandlealarm(data).then(res => {
        let data = res.data
        for (let i = 0; i < data.length; i++) {
          if (data[i].config !== '' && typeof data[i].config === 'string') {
            let config = JSON.parse(data[i].config)
            while (typeof config === 'string') {
              config = JSON.parse(config)
            }
            data[i].config = config
          }
        }
        this.alarmList = data
      }).catch(() => {})
    },
    getUrl (item) {
      let url = this.iconType[4].url
      for (let i = 0; i < this.iconType.length; i++) {
        if (this.iconType[i].type === item.alarm_type) {
          url = this.iconType[i].url
        }
      }
      return url
    },
    // 判断报警类型
    getAlarmType (atype) {
      return this.common.getAlarmType(atype)
    },
    getDname (item) {
      if (item.childdevice !== null) {
        return item.device.name + '/' + item.childdevice.name
      } else if (item.device) {
        return item.device.name
      } else {
        return '未知设备'
      }
    },
    getShowVal (item) {
      let show = false
      if (item.subdid === 0) { // 主机
        if (item.device !== null) {
          if (item.device.dtype === 503 ||
            item.device.dtype === 504 ||
            item.device.dtype === 507) {
            show = true
          }
        }
      } else { // 子机
        if (item.childdevice !== null) {
          if (item.childdevice.dtype === 2 ||
            item.childdevice.dtype === 12 ||
            item.childdevice.dtype === 13 ||
            item.childdevice.dtype === 52 ||
            item.childdevice.dtype === 11 ||
            item.childdevice.dtype === 14) {
            show = true
          }
        }
      }
      return show
    },
    // 帕斯卡转兆帕
    getMPaName (pressure) {
      return pressure / 1000000
    },
    // 水位
    getLevelName (level) {
      return level / 100
    },
    sendHandleAlarm () {
      let data = {
        did: this.deviceData.id,
        content: '已处理'
      }
      handleallalarm(data).then(res => {
        this.showAdd = true
        let vm = this
        this.$emit('getFatherChange', data.cnt)
        setTimeout(() => {
          vm.$emit('change', false)
        }, 1000)
      }).catch(() => {
        this.addWarn = true
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/device/alarmList.vue